// extracted by mini-css-extract-plugin
export var activityContainer = "_o2-0";
export var typingIndicatorContainer = "_o2-1";
export var typingIndicatorDot = "_o2-2";
export var wave = "_o2-3";